import React from 'react';
import T from 'i18n-react';
import TextInput from '../../TextInput';
import InputFeedback from '../../InputFeedback';
import withValidation from './withValidation';
import Label from '../../Label';
import PropTypes from 'prop-types';
import { isAbove18years } from '../../../utils/loaLawyerHelpers';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker-cssmodules.css';
import moment from 'moment';

const PaxForm = props => {
  const {
    values = {},
    errors = {},
    touched = {},
    handleChange,
    handleBlur,
    handleSubmit,
    allCountries = [],
    disablePaxName,
    disablePaxDate,
  } = props;

  const inputProps = ({
    id,
    type = 'text',
    label,
    disabled = false
  }) => ({
    type,
    id,
    label: T.translate(label),
    placeholder: T.translate(label),
    value: values[id],
    onChange: handleChange,
    onBlur: handleBlur,
    className: errors[id] && 'border--error',
    disabled,
  });

  const showError = field => touched[field] && errors[field];
  const errorsArray = Object.keys(errors)
    .map(showError)
    .filter(value => value !== undefined);
  const error = errorsArray[0] ? errorsArray[0] : '';

  const handleDateChange = date => {
    const utcDate = moment(date).add(moment(date).utcOffset(), 'minutes').toISOString();
    props.setFieldValue('birthDate', utcDate, true);
  }

  const birthDate = values.birthDate ? moment.utc(values.birthDate).subtract(moment(values.birthDate).utcOffset(), 'minutes').toDate() : null
  const maxDate = new Date()
  const dateDisabled = Boolean(values.birthDate && disablePaxDate)

  return (
    <React.Fragment>
      <InputFeedback error={error} />
      <form onSubmit={handleSubmit}>
        <TextInput {...inputProps({
            id: 'firstName',
            label: 'firstNameInput',
            disabled: values.firstName && disablePaxName,
          })}
        />
        <TextInput {...inputProps({
            id: 'lastName',
            label: 'lastNameInput',
            disabled: values.lastName && disablePaxName,
          })}
        />
        <div className={`option ${errors.birthDate && 'border--error'}`}>
          <Label style={dateDisabled ? {opacity: 0.5} : null}>{T.translate('birthDateInput')}</Label>
          <DatePicker
            selected={birthDate}
            id="birthDate"
            onChange={handleDateChange}
            maxDate={maxDate}
            disabled={dateDisabled}
            showYearDropdown
            scrollableYearDropdown
            dateFormat="dd/MM/yyyy"
            yearDropdownItemNumber={90}
          />
        </div>

        <TextInput {...inputProps({ id: 'birthPlace', label: 'birthPlaceInput' })}/>
        {isAbove18years(values.birthDate) && (
          <div>
            <TextInput {...inputProps({ id: 'street', label: 'streetInput' })} />
            <TextInput {...inputProps({ id: 'postalCode', label: 'postalInput' })} />
            <TextInput {...inputProps({ id: 'city', label: 'cityInput' })} />
            <div className={`option ${errors.country && 'border--error'}`}>
              <Label>{T.translate('country')}</Label>
              <select
                name="country"
                value={values.country}
                onChange={handleChange}
              >
              <option key={'default'} value={undefined}>
                {''}
              </option>
                {allCountries.map(({ label, value }) => (
                  <option key={label} value={value}>
                    {label}
                  </option>
                ))}
              </select>
            </div>
            <TextInput {...inputProps({ id: 'profession', label: 'proffInput' })}/>
          </div>
        )}

        <div className="row">
          <div />
          <div className="valider">
            <button className="btn">{T.translate('next')}</button>
          </div>
        </div>
      </form>
    </React.Fragment>
  );
};

PaxForm.propTypes = {
  values: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  allCountries: PropTypes.array.isRequired,
};

export default withValidation(PaxForm);



// WEBPACK FOOTER //
// ./src/components/LoaLawyer/Form/PaxForm.js